import { makeAutoObservable, observable  } from "mobx";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { SettingService } from "../services/ebendoSettingsService";
class EbendoSettingStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedKey = "1";
  isworking = false;
  ebendoSettings = {};
  ebendoSettingsLoaded = false;
  isSettingsModified = false;
  isSaving = false;

  async loadEbendoSettings() {
    try {
      if (!this.ebendoSettingsLoaded) {
        const res = await SettingService.loadEbendoSettings();

        this.ebendoSettingsLoaded = true;
        this.ebendoSettings = res;
        // console.log(res);
      }
    } catch (error) {
      throw error;
    }
  }

  async saveEbendoSettings() {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const retval = await SettingService.saveFlasSettings(
        this.ebendoSettings,
        uploadedBy
      );
      return retval;
    } catch (error) {
      throw error;
    }
  }
}

const ebendoSettingStore = new EbendoSettingStore();
export default ebendoSettingStore;

